document.addEventListener('DOMContentLoaded', () => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const sections = Array.from(document.querySelectorAll('.shopify-section')).filter(
    (s) => !s.closest('.shopify-section-group-header-group') &&
           !s.closest('.shopify-section-group-footer-group')
  );

  if (reduce) {
    sections.forEach((s) => s.classList.add('sr-section', 'is-revealed'));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -8% 0px' });

  sections.forEach((s) => {
    s.classList.add('sr-section');
    observer.observe(s);
  });
});